/**
 * The URL-safe identifier both catalog editors derive from a record's English
 * name: lower case, runs of anything else collapsed to one dash, no dash at
 * either end. "Surface Products" → "surface-products".
 */
export const generateSlug = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
};
